// https://stackoverflow.com/a/14966131
export default function downloadContent(
  content: string,
  { fileName, contentType }: { fileName: string; contentType: string }
): void {
  const encodedUri = encodeURI(`data:${contentType};charset=utf-8,${content}`);
  const link = document.createElement("a");
  link.setAttribute("href", encodedUri);
  link.setAttribute("download", fileName);
  document.body.appendChild(link); // Required for FF

  link.click();
}
